// extracted by mini-css-extract-plugin
export default {"back":"styles_back__-Z5Pq"};